import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { observer } from "mobx-react";
import React, {
  ChangeEvent,
  ChangeEventHandler,
  useCallback,
  useEffect,
  useState,
} from "react";
import toast from "react-hot-toast";
import { FormattedMessage } from "react-intl";
import { useLocation } from "react-router-dom";
import { ActionType } from "../../constants/enums/action-type-enum";
import { ModuleType } from "../../constants/enums/module-type-enum";
import userTypeEnum from "../../constants/enums/user-type-enum";
import { useStore } from "../../contexts/store-provider";
import { isOperationPermittedRoleBase } from "../../helpers/action-permission-helper";
import {
  getStoreIdFromLocalStorage,
  getUserTypeFromLocalStorage,
} from "../../helpers/localstorage-helper";
import { IShiftManagementList } from "../../models/response/IShiftManagementResponse";
import FormLoader from "../../shared-components/FormLoader/FormLoader";
import DropdownInput from "../../shared-components/input/DropdownInput";
import LanguageSlider from "../../shared-components/language-slider/language-slider";
import AddPopupHOC from "../../shared-components/popup/add/add-popup-hoc";
import DeletePopup from "../../shared-components/popup/delete/delete-popup";
import DeletePopupHOC from "../../shared-components/popup/delete/delete-popup-hoc";
import ShowPopupHOC from "../../shared-components/popup/show/show-popup-hoc";
import { formatMessage } from "../../translations/format-message";
import AddShiftManagement from "./components/add-edit-shift";
import DraggableShift from "./components/draggable-shift";
import ScheduleGrid from "./components/scheduler-grid";
import "./shift-management.css";

const ShiftManagement: React.FC = (props: any) => {
  const location = useLocation();
  const state = location.state as { StoreId?: number };
  const { shiftManagementStore, masterManagementStore } = useStore();
  const [dates, setDates] = useState<Date[]>([]);

  const [showInvalidShifts, setShowInvalidShifts] = useState<boolean | null>(
    false
  );

  const {
    allShiftManagement,
    DeleteShiftManagementService,
    getShiftScheduleListState,
    // addUpdateShiftManagementState,
    deleteShiftManagementState,
    addShiftScheduleListState,
    inProgress,
    copyScheduleListState,
    deleteShiftScheduleState,
    GetShiftManagementListFilterByStoreIdService,
    resetDeleteShiftManagementState,
    resetShiftBusinessHours,
    resetGetShiftScheduleList,
    GetAllStaffShiftOptionServiceByStoreId,
    setShiftBusinessHours
  } = shiftManagementStore;

  const {
    GetAllStoreOptionService,
    getAllStoreOptions,
    GetReservationSettingByIdService,
    resetGetByIdReservationSettingState,
    reservationSettingBusinessVM,
  } = masterManagementStore;
  const [selectedId, setSelectedId] = useState<number>(0);
  const [storeIdSearch, setStoreIdSearch] = useState<number>(-1);
  const [selectedShiftDelete, setselectedShiftDelete] = useState<number>(-1);

  let StoreId = state?.StoreId || 0;
  const userType = getUserTypeFromLocalStorage();
  if (userType === userTypeEnum[userTypeEnum.Store]) {
    StoreId = getStoreIdFromLocalStorage() || 0;
  }

  const handleEditShift = (shift: IShiftManagementList) => {
    setSelectedId(shift.Id);
    props.addToggleHandler();
  };

  const openAddShiftManagementHandler = () => {
    setSelectedId(-1);
    props.addToggleHandler();
  };

  const deleteSubmitHandler = () => {
    DeleteShiftManagementService(selectedShiftDelete);
  };

  const handleStoreIdSearch: ChangeEventHandler<HTMLSelectElement> =
    useCallback((event: ChangeEvent<HTMLSelectElement>) => {
      setStoreIdSearch(event.target.value as unknown as number);
    }, []);

  const filterInvalid = (value: any) => {
    setShowInvalidShifts(value?.target?.checked);
  };

  let callShiftList = useCallback(() => {
    GetShiftManagementListFilterByStoreIdService(
        StoreId || storeIdSearch,
        showInvalidShifts ? 1 : 0
      );
  }, [
    GetShiftManagementListFilterByStoreIdService,
    StoreId,
    storeIdSearch,
    showInvalidShifts
  ]);
  
  const callAllStaffService = useCallback(() => {
    if(storeIdSearch > 0 || StoreId > 0){
      GetAllStaffShiftOptionServiceByStoreId(StoreId || storeIdSearch);
      GetReservationSettingByIdService(StoreId || storeIdSearch);
    }
  }, [
    GetAllStaffShiftOptionServiceByStoreId,
    GetReservationSettingByIdService,
    StoreId,
    storeIdSearch
  ]);

  useEffect(() => {
   if(userType !== userTypeEnum[userTypeEnum.Store])
      GetAllStoreOptionService();
    return(()=>{
      resetGetByIdReservationSettingState();
      resetShiftBusinessHours();
      resetGetShiftScheduleList();
    })
  }, []);

  useEffect(() => {
   setShiftBusinessHours(reservationSettingBusinessVM);
  }, [reservationSettingBusinessVM]);

  useEffect(() => {
    callAllStaffService();
  }, [callAllStaffService]);

  useEffect(() => {
    callShiftList();
  }, [callShiftList]);

  useEffect(() => {
    if (deleteShiftManagementState.success) {
      toast.success(formatMessage("shift_deleted_successfully"));
      if (props.showDeletePopup) props.deletePopupToggleHandler();
      callShiftList();
      resetDeleteShiftManagementState();
    }
  }, [callShiftList, deleteShiftManagementState.success, props]);

  useEffect(() => {
    if (deleteShiftManagementState.error) {
      props.deletePopupToggleHandler();
      resetDeleteShiftManagementState();
    }
  }, [deleteShiftManagementState.error]);
  // useEffect(() => {
  //   if (deleteShiftManagementState.success) {
  //     props.addToggleHandler();
  //     resetDeleteShiftManagementState();
  //   }
  // }, [
  //   deleteShiftManagementState.success,
  //   props,
  //   resetDeleteShiftManagementState,
  // ]);

  return (
    <React.Fragment>
      {props.showAddPopup && (
        <AddShiftManagement
          storeId={StoreId || storeIdSearch}
          id={selectedId}
          modalClosed={props.addToggleHandler}
          dates={dates}
          shiftStatus={showInvalidShifts ? 1 : 0}
        />
      )}
      {props.showDeletePopup && (
        <DeletePopup
          modalSubmit={deleteSubmitHandler}
          modalClosed={() => {
            props.deletePopupToggleHandler();
          }}
          isLoading={deleteShiftManagementState.inProgress}
          title={formatMessage("delete_confirmation")}
          message={formatMessage("are_you_sure_you_want_to_delete_this_shift?")}
        />
      )}

      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div className="row align-items-center">
          <div className="col-6">
            <div className="page_title_wrap">
              <h1 className="page_title">
                <FormattedMessage id="shift_management" />
              </h1>
              <ol className="breadcrumb">
                {/* <li className="breadcrumb-item">
                  <FormattedMessage id="master_management" />
                </li> */}
                <li className="breadcrumb-item active" aria-current="page">
                  <FormattedMessage id="shift_management" />
                </li>
              </ol>
            </div>
          </div>
          <div className="col-6">
            <ul className="add-list">
              <li>
                <LanguageSlider />
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="container-fluid mt-4 p-0">
        {(getShiftScheduleListState.inProgress ||
          deleteShiftManagementState.inProgress ||
          addShiftScheduleListState.inProgress ||
          inProgress ||
          copyScheduleListState.inProgress ||
          deleteShiftScheduleState.inProgress) && (
          <FormLoader
            loading={
              getShiftScheduleListState.inProgress ||
              deleteShiftManagementState.inProgress ||
              addShiftScheduleListState.inProgress ||
              inProgress ||
              copyScheduleListState.inProgress ||
              deleteShiftScheduleState.inProgress
            }
          />
        )}

        <div className="row align-items-center">
          <div className="col-6">
            {userType !== userTypeEnum[userTypeEnum.Store] && (
              <>
                {StoreId > 0 || storeIdSearch > 0 ? (
                  <h2 className="shifts-heading">{formatMessage("shifts")}</h2>
                ) : (
                  <h3>
                    <FormattedMessage id="please_select_store" />
                  </h3>
                )}
              </>
            )}
          </div>
          <div className="col-lg-6 d-flex justify-content-end align-items-center">
            {userType !== userTypeEnum[userTypeEnum.Store] && (
              <>
                {!(StoreId > 0) && storeIdSearch && (
                  <div className="input-group w-50">
                    <div className="input-group-text">
                      <span role="button" onClick={() => {}}>
                        <FontAwesomeIcon icon={faSearch} />
                      </span>
                    </div>
                    <DropdownInput
                      className="form-control"
                      placeholder={formatMessage("search_by_store_name")}
                      value={storeIdSearch}
                      onChange={handleStoreIdSearch}
                      options={getAllStoreOptions.map((option) => ({
                        label: option.value,
                        value: option.id,
                      }))}
                    />
                  </div>
                )}
              </>
            )}
            {(StoreId > 0 || storeIdSearch > 0) &&
              isOperationPermittedRoleBase(
                ModuleType.ShiftManagement,
                ActionType.Add
              ) && (
                <React.Fragment>
                  <input
                    type="checkbox"
                    id="blockedCustomersCheckbox"
                    className="form-check-input m-0"
                    checked={showInvalidShifts == false ? false : true}
                    onChange={(e: any) => filterInvalid(e)}
                  />
                  <label
                    htmlFor="blockedCustomersCheckbox"
                    className="form-check-label ms-2"
                  >
                    {formatMessage("invalid_shifts")}
                  </label>
                  <button
                    className="btn btn-primary ms-3"
                    onClick={openAddShiftManagementHandler}
                  >
                    <i className="bi bi-plus-lg me-1"></i>
                    {<FormattedMessage id="add_shift" />}
                  </button>
                </React.Fragment>
              )}
          </div>
        </div>
        <div className="schedule_wrapper mt-2">
          {allShiftManagement.map((shift: IShiftManagementList) => (
            <DraggableShift
              key={shift.Id}
              shift={{
                ...shift,
              }}
              isDisabled={
                !isOperationPermittedRoleBase(
                  ModuleType.ShiftManagement,
                  ActionType.Add
                )
              }
              isScheduled={false}
              onEdit={() => handleEditShift(shift)}
              onDelete={(shiftId: number) => {
                setselectedShiftDelete(shiftId);
                props.deletePopupToggleHandler();
              }}
              isSchedulePublished={false}
            />
          ))}
        </div>
        {/* Schedule Section */}
        {
          allShiftManagement.length === 0 &&
           <FormattedMessage id={showInvalidShifts ? "no_invalid_shift_found" : "no_shift_found"} />
        }
        {
          (StoreId > 0 || storeIdSearch > 0) && (
            <div className="card">
              <ScheduleGrid
                storeId={StoreId || storeIdSearch}
                addToggleHandler={props.addToggleHandler}
                setSelectedShift={setSelectedId}
                dates={dates}
                setDates={setDates}
                isDisabled={
                  !isOperationPermittedRoleBase(
                    ModuleType.ShiftManagement,
                    ActionType.Add
                  )
                }
                showInvalidShifts={showInvalidShifts}
              />
            </div>
          )
        }
      </div>
    </React.Fragment>
  );
};

export default AddPopupHOC(
  ShowPopupHOC(DeletePopupHOC(observer(ShiftManagement)))
);
